<template>
  <div>
    <!-- <euros-header :titre="getTitre()" pathRetour="/logout" btnRetour="Déconnexion"></euros-header> -->
    <tab-bar currentActive="home" @changeActive="changeTabbar"></tab-bar>
    <div class="d-flex flex-column h-100vh">
      <div>
        <tab-activites @changeActive="changeActivite" active="genou"></tab-activites>
      </div>
      <div v-if="showPassed" class="container-fluid bg-blue flex-grow-1 overflow-auto">
        <div class="row">
          <div class="col-md-12 pb-5">
            <div v-if="patients_past_week.length > 0" class="mb-0 mt-3">
              <h3>Semaine dernière</h3>
              <patients-list type="genou" :patients="patients_past_week" :archive="archive" :filter-text="filterText"
                @itemclick="itemclick"></patients-list>
            </div>
            <div v-if="patients_past_month.length > 0" class="mb-0 mt-3">
              <h3>Mois dernier</h3>
              <patients-list type="genou" :patients="patients_past_month" :archive="archive" :filter-text="filterText"
                @itemclick="itemclick"></patients-list>
            </div>
            <div v-if="patients_past_other.length > 0" class="mb-0 mt-3">
              <h3>Supérieur à un mois</h3>
              <patients-list type="genou" :patients="patients_past_other" :archive="archive" :filter-text="filterText"
                @itemclick="itemclick"></patients-list>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="container-fluid bg-blue mt-3 flex-grow-1 overflow-auto">
        <!-- <div class="row pt-2">
        <div
          class="col-sm-9 d-flex align-items-center justify-content-between justify-content-sm-end flex-wrap flex-sm-nowrap">
          <div>
            <m-form-text class="mt-0" placeholder="Rechercher" v-model="filterText" name="filtertext"></m-form-text>
          </div>
        </div>
      </div> -->
        <div class="row mb-4"
          v-if="patients_past_week.length + patients_past_month.length + patients_past_other.length > 0">
          <div class="col">
            <h3>Passées</h3>
            <div class="border rounded-lg p-2" @click="showPassed = !showPassed">
              <div class="float-right">
                <icon width="24" height="24" name="arrow-right"></icon>
              </div>
              <strong>{{ patients_past_week.length + patients_past_month.length + patients_past_other.length }}
                planification{{
                  patients_past_week.length + patients_past_month.length + patients_past_other.length > 1 ? "s" : ""
                }}</strong><br />
              Fichiers / Comptes-rendus post-opératoire.
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 pb-5">
            <div v-if="patients_today.length > 0" class="mb-3">
              <!-- <m-form-checkbox v-model="archive" label="Voir les archivés" name="archive" :reverse="true"></m-form-checkbox> -->
              <h3 class="mb-0">Aujourd'hui</h3>
              <patients-list type="genou" :patients="patients_today" :archive="archive" :filter-text="filterText"
                @itemclick="itemclick"></patients-list>
            </div>

            <div v-if="patients_tomorrow.length > 0" class="mb-3">
              <h3 class="mb-0">Demain</h3>
              <patients-list type="genou" :patients="patients_tomorrow" :archive="archive" :filter-text="filterText"
                @itemclick="itemclick"></patients-list>
            </div>

            <div v-if="patients_future.length > 0" class="mb-3">
              <h3 class="mb-0">Futurs</h3>
              <patients-list type="genou" :patients="patients_future" :archive="archive" :filter-text="filterText"
                @itemclick="itemclick"></patients-list>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="text-center">Version : {{ version }}</div> -->

    <div class="winmodal" v-if="!$store.state.cgu.validated || $store.state.help.patients"></div>
    <m-confirm-dialog v-model="confirmDestroyDialog" :text="confirmDestroyText" title="Confirmation" width="400px"
      @canceled="confirmDestroyDialog = false" @confirmed="destroyOk"></m-confirm-dialog>

    <div class="cguwin" v-if="!$store.state.cgu.validated">
      <!-- <div class="cguclose">Fermer</div> -->
      <div class="d-flex flex-column h-100">
        <div class="flex-grow-1 cguwin-content">
          <h5>Condition Général d'Utilisation (version {{ $store.state.cgu.cg_version }})</h5>
          <div class="mb-5" v-html="$store.state.cgu.cg_text"></div>
        </div>
        <div class="pt-2">
          <button class="btn btn-primary mb-0" @click="cguAccept">J'accepte</button>
        </div>
      </div>
    </div>

    <div class="helpwin helpwinleft0" v-if="$store.state.help.patients">
      <div class="winclose">
        <label for="notdisplayanymore" style="margin: -5px 30px"><input type="checkbox" id="notdisplayanymore"
            v-model="notdisplayanymore" />Ne plus afficher</label>
        <a href="javascript:void(0);" @click="$store.commit('set_help', ['patients', notdisplayanymore])">
          <icon width="24" height="24" name="times" class="" color="black"></icon>
        </a>
      </div>
      <div class="row">
        <div class="col-md-3 helpwinleftcol0">
          <!-- <img src="/images/loic-gauche.png" class="img-fluid" alt="" /> -->
        </div>
        <div class="col-md-6">
          <h3>Bienvenue dans l'outil d’aide à la planification EUROS.</h3>
          <!-- <p>Laissez-moi vous guidez lors de votre première utilisation !</p> -->
          <p>Cliquez sur NOUVEAU PATIENT pour commencer.</p>
          <div>
            <button class="btn btn-primary" @click="newPatient">NOUVEAU PATIENT</button>
          </div>
        </div>
        <div class="col-md-3">
          <img src="/images/aide/01-nouveau-patient.png" class="img-fluid" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { version } from "../../package.json";
import PatientsList from "./PatientsList.vue";
Vue.component("patients-list", PatientsList);

export default {
  name: "home-patients",
  components: {},
  data() {
    return {
      notdisplayanymore: false,
      version,
      filterText: "",
      tsSearch: null,
      archive: false,
      patients: [],
      patients_today: [],
      patients_tomorrow: [],
      patients_past_week: [],
      patients_past_month: [],
      patients_past_other: [],
      patients_future: [],
      patients_total: 0,
      patients_skip: 0,
      patients_limit: 100,
      confirmDestroyDialog: false,
      confirmDestroyText: "",
      confirmDestroyObj: null,
      sortFields: ["t1.createdAt"],
      sortOrder: "desc",
      showPassed: false
    };
  },
  async mounted() {
    window.scrollTo(0, 0);
    // console.log("this.$route.path", this.$route.path);
    this.$store.dispatch("addHistoryUrl", this.$route.path);
    this.loadPatients();
    await this.$store.dispatch("setversion");
  },
  watch: {
    archive(val) {
      this.loadPatients();
    },
    filterText: function (val) {
      if (this.tsSearch) window.clearTimeout(this.tsSearch);
      this.tsSearch = window.setTimeout(() => {
        this.loadPatients(val);
      }, 500);
    }
  },
  computed: {},
  methods: {
    changeTabbar(where) {
      if (where == "patients") {
        this.showPassed = false;
      }
    },
    changeActivite(where) {
      // this.$store.commit("set_current_active", evt);
      // this.$router.push("/" + evt).catch(err => {});
      if (where === "hanche") {
        this.showPassed = false;
        this.$router.push("/patients").catch(err => {});
      } else {
        this.$router.push("/" + where).catch(err => {});
      }
    },
    reloadApp() {
      window.location.reload();
    },
    async cguAccept() {
      // this.cgu_validated = true;
      // let response =
      await this.$axios.post(this.$config.server_url + "/api/1.0/cgus/valid", { cg_id: this.$store.state.cgu.cg_id });
      this.$store.commit("set_cgu_validated");
    },
    getTitre() {
      let titre = `Liste de vos 30 derniers patients`;
      if (this.archive || this.patients_total < 30) titre = `Liste de vos ${this.patients.length} patients`;
      return titre;
    },
    sortContacts(tabSearchFields) {
      if (tabSearchFields.length && this.sortFields.length && tabSearchFields[0] == this.sortFields[0]) {
        this.sortOrder = this.sortOrder == "asc" ? "desc" : "asc";
      }
      this.sortFields = tabSearchFields;
      if (tabSearchFields[0] === "t1.createdAt") {
        this.patients.sort((a, b) => {
          if (this.sortOrder === "asc") {
            if (this.$dayjs(a.createdAt).isBefore(b.createdAt)) return -1;
            if (this.$dayjs(a.createdAt).isAfter(b.createdAt)) return 1;
            if (this.$dayjs(a.createdAt).isSame(b.createdAt)) return 0;
          } else {
            if (this.$dayjs(a.createdAt).isBefore(b.createdAt)) return 1;
            if (this.$dayjs(a.createdAt).isAfter(b.createdAt)) return -1;
            if (this.$dayjs(a.createdAt).isSame(b.createdAt)) return 0;
          }
        });
      }
      if (tabSearchFields[0] === "pa_birthdate") {
        this.patients.sort((a, b) => {
          if (this.sortOrder === "asc") {
            if (this.$dayjs(a.pa_birthdate).isBefore(b.pa_birthdate)) return -1;
            if (this.$dayjs(a.pa_birthdate).isAfter(b.pa_birthdate)) return 1;
            if (this.$dayjs(a.pa_birthdate).isSame(b.pa_birthdate)) return 0;
          } else {
            if (this.$dayjs(a.pa_birthdate).isBefore(b.pa_birthdate)) return 1;
            if (this.$dayjs(a.pa_birthdate).isAfter(b.pa_birthdate)) return -1;
            if (this.$dayjs(a.pa_birthdate).isSame(b.pa_birthdate)) return 0;
          }
        });
      } else {
        this.loadPatients();
      }
    },
    print(item) {
      window.open(
        this.$config.server_url +
        "/api/1.0/patients/" +
        item.pa_id +
        "/print" +
        "?token=" +
        this.$store.state.accesstoken +
        "&origin=webapp" +
        "&d=" +
        new Date().getTime()
      );
    },
    destroy(row_pa) {
      // console.log("row_pa", row_pa);
      this.confirmDestroyObj = row_pa;
      this.confirmDestroyText = `Souhaitez-vous effacer le patient ${row_pa.pa_name} ?`;
      this.confirmDestroyDialog = true;
    },
    async destroyOk() {
      // let response =
      await this.$axios.delete(this.$config.server_url + "/api/1.0/patients/" + this.confirmDestroyObj.pa_id, {});
      this.confirmDestroyDialog = false;
      this.loadPatients();
    },
    async loadPatients() {
      let limit = 30;
      let sort = this.sortFields.reduce((accumulator, field) => {
        if (accumulator) accumulator += ", ";
        accumulator += field + " " + this.sortOrder;
        return accumulator;
      }, "");
      if (this.archive) limit = 100000;
      let params = {
        pa_archive: this.archive,
        // text: this.filterText,
        sort: sort,
        limit: limit,
        pa_type: "genou"
      };
      let response = await this.$axios.get(this.$config.server_url + "/api/1.0/patients", { params });
      this.patients_today = response.data.data
        .filter(p => {
          return this.$dayjs(p.pa_dateoperation).isSame(this.$dayjs(), "day");
        })
        .sort((a, b) => {
          return this.$dayjs(a.pa_dateoperation).diff(this.$dayjs(b.pa_dateoperation), "day");
        });
      this.patients_tomorrow = response.data.data
        .filter(p => {
          return this.$dayjs(p.pa_dateoperation).isSame(this.$dayjs().add(1, "day"), "day");
        })
        .sort((a, b) => {
          return this.$dayjs(a.pa_dateoperation).diff(this.$dayjs(b.pa_dateoperation), "day");
        });
      this.patients_future = response.data.data
        .filter(p => {
          return this.$dayjs(p.pa_dateoperation).isAfter(this.$dayjs().add(1, "day"), "day");
        })
        .sort((a, b) => {
          return this.$dayjs(a.pa_dateoperation).diff(this.$dayjs(b.pa_dateoperation), "day");
        });
      this.patients_past_week = response.data.data
        .filter(p => {
          return this.$dayjs(p.pa_dateoperation).isBetween(this.$dayjs().add(-7, "day"), this.$dayjs(), "day");
        })
        .sort((a, b) => {
          return this.$dayjs(a.pa_dateoperation).diff(this.$dayjs(b.pa_dateoperation), "day") * -1;
        });
      this.patients_past_month = response.data.data
        .filter(p => {
          return this.$dayjs(p.pa_dateoperation).isBetween(this.$dayjs().add(-30, "day"), this.$dayjs().add(-7, "day"), "day");
        })
        .sort((a, b) => {
          return this.$dayjs(a.pa_dateoperation).diff(this.$dayjs(b.pa_dateoperation), "day") * -1;
        });
      this.patients_past_other = response.data.data
        .filter(p => {
          return this.$dayjs(p.pa_dateoperation).isBefore(this.$dayjs().add(-30, "day"), "day");
        })
        .sort((a, b) => {
          return this.$dayjs(a.pa_dateoperation).diff(this.$dayjs(b.pa_dateoperation), "day") * -1;
        });
      // console.log("🚀 ~ loadPatients ~ this.patients:", this.patients);
      // this.patients = this.patients.filter(p => {
      //   if (!this.filterText) return true;
      //   if (p.pa_name.toLocaleLowerCase("fr").indexOf(this.filterText.toLocaleLowerCase("fr")) >= 0) return true;
      //   return false;
      // });
      // if (response.data.meta) this.patients_total = response.data.meta.total;
      // else this.patients_total = this.patients.length;
    },
    newPatient() {
      this.$router.push("/chooseimage").catch(err => {});
    },
    archiver() {
      this.$router.push("/archive").catch(err => {});
    },
    itemclick(item) {
      this.$router.push("/resultgenou/" + item.pa_id).catch(err => {});
    }
  }
};
</script>

<style scoped lang="scss">
.m-form-checkbox {
  margin-bottom: 0;
}

.cguwin {
  position: fixed;
  background-color: white;
  border: 1px solid black;
  top: 5%;
  height: 90%;
  width: 90%;
  left: 5%;
  z-index: 10001;
  padding: 20px;

  // overflow: auto;
  .btn-jaccepte {
    position: absolute;
    bottom: 5px;
  }
}

.cguwin-content {
  overflow: auto;
}

@media (min-width: 576px) {
  .helpwin {}
}

@media (min-width: 768px) {
  .helpwin {}
}

.h-100vh {
  height: 100vh;
}
</style>
